import React, { useState, useEffect } from 'react';
import { Save, RefreshCw, Plus } from 'lucide-react';
import { adminAPI } from '../lib/api';

const AdminCoefficientsTURPE = () => {
  const [coefficients, setCoefficients] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [dataSource, setDataSource] = useState('default');

  const FORMULES_PAR_TENSION = {
    'HTA': [
      { id: 'HTACU5_PF', label: 'HTACU5 PF' },
      { id: 'HTACU5_PM', label: 'HTACU5 PM' },
      { id: 'HTALU5_PF', label: 'HTALU5 PF' },
      { id: 'HTALU5_PM', label: 'HTALU5 PM' }
    ],
    'BTSUP': [
      { id: 'BTSUPCU4', label: 'BTSUPCU4' },
      { id: 'BTSUPLU4', label: 'BTSUPLU4' }
    ],
    'BTINF': [
      { id: 'BTINFCU', label: 'BTINFCU' },
      { id: 'BTINFCU4', label: 'BTINFCU4' },
      { id: 'BTINFMU4', label: 'BTINFMU4' },
      { id: 'BTINFMUDT', label: 'BTINFMUDT' },
      { id: 'BTINFLU', label: 'BTINFLU' }
    ]
  };

  const PLAGES_PAR_TENSION = {
    'HTA': ['Pointe', 'HPH', 'HCH', 'HPB', 'HCB'],
    'BTSUP': ['Pointe', 'HPH', 'HCH', 'HPB', 'HCB'],
    'BTINF': ['HP', 'HC', 'Unique']
  };

  useEffect(() => {
    loadCoefficients();
  }, []);

  const loadCoefficients = async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getCoefficientsTURPE();
      const { data, source } = response.data;
      setCoefficients(data);
      setDataSource(source);
    } catch (error) {
      console.error('Erreur chargement coefficients:', error);
      // Charger les valeurs par défaut en cas d'erreur
      loadDefaultCoefficients();
    } finally {
      setLoading(false);
    }
  };

  const loadDefaultCoefficients = () => {
    // Tous les coefficients depuis Excel TURPE7
    const defaultCoeffs = {
      'HTACU5_PF': {
        'Pointe': { b: 14.41, c: 0.0574 },
        'HPH': { b: 14.41, c: 0.0423 },
        'HCH': { b: 14.41, c: 0.0199 },
        'HPB': { b: 12.55, c: 0.0101 },
        'HCB': { b: 11.22, c: 0.0069 }
      },
      'HTACU5_PM': {
        'Pointe': { b: 14.41, c: 0.0701 },
        'HPH': { b: 14.41, c: 0.0405 },
        'HCH': { b: 14.41, c: 0.0199 },
        'HPB': { b: 12.55, c: 0.0101 },
        'HCB': { b: 11.22, c: 0.0069 }
      },
      'HTALU5_PF': {
        'Pointe': { b: 35.33, c: 0.0265 },
        'HPH': { b: 32.3, c: 0.021 },
        'HCH': { b: 20.39, c: 0.0147 },
        'HPB': { b: 14.33, c: 0.0092 },
        'HCB': { b: 11.56, c: 0.0068 }
      },
      'HTALU5_PM': {
        'Pointe': { b: 38.27, c: 0.0315 },
        'HPH': { b: 34.3, c: 0.0187 },
        'HCH': { b: 20.39, c: 0.0147 },
        'HPB': { b: 14.33, c: 0.0092 },
        'HCB': { b: 11.56, c: 0.0068 }
      },
      'BTSUPCU4': {
        'HPH': { b: 17.61, c: 0.0691 },
        'HCH': { b: 15.96, c: 0.0421 },
        'HPB': { b: 14.56, c: 0.0213 },
        'HCB': { b: 11.98, c: 0.0152 }
      },
      'BTSUPLU4': {
        'HPH': { b: 30.16, c: 0.0569 },
        'HCH': { b: 21.18, c: 0.0347 },
        'HPB': { b: 16.64, c: 0.0201 },
        'HCB': { b: 12.37, c: 0.0149 }
      },
      'BTINFCU': {
        'Unique': { b: 11.07, c: 0.0484 }
      },
      'BTINFCU4': {
        'HPH': { b: 10.11, c: 0.0749 },
        'HCH': { b: 10.11, c: 0.0397 },
        'HPB': { b: 10.11, c: 0.0166 },
        'HCB': { b: 10.11, c: 0.0116 }
      },
      'BTINFMU4': {
        'HPH': { b: 12.12, c: 0.07 },
        'HCH': { b: 12.12, c: 0.0373 },
        'HPB': { b: 12.12, c: 0.0161 },
        'HCB': { b: 12.12, c: 0.0111 }
      },
      'BTINFMUDT': {
        'HP': { b: 13.49, c: 0.0494 },
        'HC': { b: 13.49, c: 0.035 }
      },
      'BTINFLU': {
        'Unique': { b: 93.13, c: 0.0125 }
      }
    };
    
    setCoefficients(defaultCoeffs);
  };

  const updateCoefficient = (formule, plage, type, valeur) => {
    const newCoeffs = { ...coefficients };
    if (!newCoeffs[formule]) newCoeffs[formule] = {};
    if (!newCoeffs[formule][plage]) newCoeffs[formule][plage] = { b: 0, c: 0 };
    newCoeffs[formule][plage][type] = parseFloat(valeur) || 0;
    setCoefficients(newCoeffs);
    setHasChanges(true);
  };

  const handleSave = async () => {
    if (!window.confirm('Enregistrer les coefficients TURPE ?')) return;
    
    setSaving(true);
    try {
      await adminAPI.updateCoefficientsTURPE(coefficients);
      alert('Coefficients sauvegardés !');
      setHasChanges(false);
      setDataSource('database');
    } catch (error) {
      console.error('Erreur sauvegarde:', error);
      alert(error.response?.data?.detail || 'Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-4xl font-heading font-semibold text-[#191D1E] tracking-tight">
            Coefficients Pondérateurs TURPE
          </h1>
          <p className="text-[#687175] mt-2">
            Gestion des coefficients b (puissance) et c (énergie) par formule tarifaire
          </p>
        </div>
        <div className="flex gap-3">
          {hasChanges && (
            <button onClick={() => window.location.reload()} className="flex items-center gap-2 border border-[#BFC6CC] text-[#687175] hover:bg-[#F5F6F9] px-4 py-2 rounded-lg">
              <RefreshCw className="w-4 h-4" /> Annuler
            </button>
          )}
          <button onClick={handleSave} disabled={!hasChanges || saving} className="flex items-center gap-2 bg-[#397DFF] hover:bg-[#4672B6] text-white px-6 py-3 rounded-lg disabled:opacity-50">
            <Save className="w-5 h-5" /> {saving ? 'Sauvegarde...' : 'Enregistrer'}
          </button>
        </div>
      </div>

      {hasChanges && (
        <div className="mb-6 p-4 bg-[#F9C80E]/10 border border-[#F9C80E] rounded-lg">
          <p className="text-sm text-[#191D1E]">⚠️ Modifications non enregistrées</p>
        </div>
      )}

      {/* Tableau par tension */}
      <div className="space-y-8">
        {Object.entries(FORMULES_PAR_TENSION).map(([tension, formules]) => {
          const plages = PLAGES_PAR_TENSION[tension];
          
          return (
            <div key={tension} className="bg-white border border-[#BFC6CC] rounded-lg overflow-hidden">
              <div className="bg-[#397DFF] text-white px-6 py-3">
                <h3 className="font-semibold text-lg">{tension}</h3>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-[#F5F6F9]">
                    <tr>
                      <th rowSpan="2" className="px-4 py-3 text-left text-sm font-semibold text-[#191D1E] border-r-2 border-[#397DFF]">
                        Formule Tarifaire
                      </th>
                      {plages.map((plage) => (
                        <th key={plage} colSpan="2" className="px-4 py-2 text-center text-xs font-semibold text-[#191D1E] border-l border-[#BFC6CC]">
                          {plage}
                        </th>
                      ))}
                    </tr>
                    <tr>
                      {plages.map((plage) => (
                        <React.Fragment key={plage}>
                          <th className="px-2 py-2 text-center text-xs text-[#687175] bg-[#E8F4FD] border-l border-[#BFC6CC]">
                            b (€/kW/an)
                          </th>
                          <th className="px-2 py-2 text-center text-xs text-[#687175] bg-[#F9C80E]/10 border-l border-[#BFC6CC]">
                            c (€/kWh)
                          </th>
                        </React.Fragment>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#BFC6CC]">
                    {formules.map((formule) => (
                      <tr key={formule.id} className="hover:bg-[#F5F6F9]">
                        <td className="px-4 py-3 font-mono text-sm font-semibold text-[#191D1E] border-r-2 border-[#397DFF]">
                          {formule.label}
                        </td>
                        {plages.map((plage) => (
                          <React.Fragment key={plage}>
                            <td className="px-1 py-1 border-l border-[#BFC6CC]">
                              <input
                                type="number"
                                step="0.01"
                                value={coefficients[formule.id]?.[plage]?.b || ''}
                                onChange={(e) => updateCoefficient(formule.id, plage, 'b', e.target.value)}
                                className="w-full px-2 py-2 text-center border-0 focus:ring-2 focus:ring-[#397DFF] font-mono text-xs bg-[#E8F4FD]/30"
                                placeholder="0.00"
                              />
                            </td>
                            <td className="px-1 py-1 border-l border-[#BFC6CC]">
                              <input
                                type="number"
                                step="0.0001"
                                value={coefficients[formule.id]?.[plage]?.c || ''}
                                onChange={(e) => updateCoefficient(formule.id, plage, 'c', e.target.value)}
                                className="w-full px-2 py-2 text-center border-0 focus:ring-2 focus:ring-[#397DFF] font-mono text-xs bg-[#F9C80E]/10"
                                placeholder="0.0000"
                              />
                            </td>
                          </React.Fragment>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminCoefficientsTURPE;
